import ForwardTracker from "../../../../prop-trackers/forward-tracker.js";
import SinglePropTracker from "../../../../prop-trackers/single-prop-tracker.js";
import ValueTracker from "../../../../prop-trackers/value-tracker.js";
import { Mapper, ValueMapper } from "../../../../prop-tracker-utils/mapper.js";
import PromiseUnwrapMapper from "../../../../utils/promise-unwrap-mapper.js";

class EnvLightTrackerLoader extends ForwardTracker {
    constructor(envDataTracker, evtCtx, envLightLoader, userdata) {
        const envDataToPromiseMapper = new Mapper(envDataTracker, (key) => new Loader(evtCtx, key, envLightLoader));
        const promiseUnwrapMapper = new Mapper(envDataToPromiseMapper, (key) => new PromiseUnwrapMapper(), userdata);

        super(promiseUnwrapMapper);
    }
}

class Loader extends ValueMapper {
    constructor(evtCtx, key, envLightLoader) {
        super();

        this._evtCtx = evtCtx;
        this._envLightLoader = envLightLoader;

        this._pathTracker = new SinglePropTracker(key);
        this._pathTracker.listenNeedsUpdate(() => this.protected_needsUpdate());

        this._valueTracker = new ValueTracker();
    }

    setValue(data) {
        const events = data ? this._evtCtx.getEvents(data) : null;
        this._pathTracker.track(data, events, "path");
    }

    deleteValue() {
        this._pathTracker.track();
    }

    protected_startUpdate() {
        this._pathTracker.updateIfNeeded(({ userdata: key, prop: { oldExists, newExists, newValue } }) => {
            if (oldExists) {
                this._envLightLoader.unload(key);
            }

            if (newExists) {
                this._valueTracker.setValue(this._envLightLoader.load(key, newValue));
            } else {
                this._valueTracker.deleteValue();
            }
        });

        return this._valueTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._valueTracker.finishUpdate();
    }
}

export default EnvLightTrackerLoader;
